import { render, staticRenderFns } from "./BaseRadioButton.vue?vue&type=template&id=0071ebaa&scoped=true&"
import script from "./BaseRadioButton.vue?vue&type=script&lang=ts&"
export * from "./BaseRadioButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseRadioButton.vue?vue&type=style&index=0&id=0071ebaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0071ebaa",
  null
  
)

export default component.exports